<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12" md="6" lg="6" align-self="center">
        <div class="d-flex justify-center">
          <div class="admin__title">
            <p class="text-h1">
              {{ $t('ADMIN_HOME_TITLE') }}
            </p>

            <p class="text-body-1 grey-font mb-8">
              {{ $t('ADMIN_HOME_TEXT') }}
            </p>
          </div>
        </div>
      </v-col>

      <v-col cols="12" sm="12" md="6" lg="6">
        <div class="d-flex justify-center admin__img">
          <v-img
            :class="`mt-12 ${$vuetify.breakpoint.mdAndUp ? 'background-img' : null}`"
            :src="require('@/assets/404img.svg')"
          />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'Home',
}
</script>

<style scoped lang="scss">
.admin {
  &__title {
    width: rem(400);
  }
  &__img {
    width: 65%;
  }
}
</style>
